import {
  PT_REGISTER,
  PT_PROFILE,
  PT_OTP,
} from "../../routes/stack/paths/pt-profile";
import {
  SET_STORE_TEMP_STORE_PHONE_NO,
  SET_STORE_STARTING_NO,
} from "../../database/store-data";
import {
  api_CheckMobilePhoneNumber,
  api_SendOtp,
} from "../../connection/api/api-profile";
import { DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT } from "../../functions/funtion";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { ENTRY_MODE, TEMP_STORE_CSID } from "../../database/store-names";
import { GET_SET_STORED_DATA } from "../../database/get-stored-data";
import { ENCRYPT_STORAGE } from "../../config/config";
import { ToastMessage } from "../../components/toast-notification/toast";
import { dto_common } from "../../classes/dto-common";
import { PT_CART } from "../../routes/stack/paths/pt-cart";
import { Colors } from "../../util/colors";
import { Font } from "../../util/config-fonts";
import RENDER_DRAWER_COUNTRY from "../../components/render-drawer-country/render-drawer-country";
import DrawerSheetBottom from "../../components/BottomDrawer/drawer-bottom";
import FlagMV from "../../components/render-drawer-country/flagMV.png";
import FlagSL from "../../components/render-drawer-country/flagSL.png";
import React from "react";
import "../../styles/css/pg-profile-signin.css";
import "../../styles/css/common-btn.css";

export default class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      CountryModleOpen: false,
      logourl: "",
      logosrc: "",
      CountryCode: "",
      startingNo: "",
      isLoading: false,
      ContentLoading: true,
    };
  }

  async componentDidMount() {
    this.setState({ ContentLoading: true });
    await GET_SET_STORED_DATA();
    let CSP = dto_common.CSP;
    let natvieCountry = dto_common.NatvieCountry;
    DRAWER_SCREEN_CLOSE_BUTTON_CLICK_EVENT(() => {
      this.setState({ CountryModleOpen: false });
    });

    if (CSP === "AV") {
      this.setState({
        logosrc: require("./images/AvasLogo.png"),
      });
    } else if (CSP === "MK") {
      this.setState({
        logosrc: require("./images/MkbLogo.png"),
      });
    } else if (CSP === "DT") {
      this.setState({
        logosrc: require("./images/DaitonnLogo.png"),
      });
    }

    if (natvieCountry === "LK") {
      this.setState({
        logourl: FlagSL,
        CountryCode: "LK",
        startingNo: "+" + dto_StartupPageLoadInfo.CountryPhoneCode,
      });
    } else if (natvieCountry === "MV") {
      this.setState({
        logourl: FlagMV,
        CountryCode: "MV",
        startingNo: "+" + dto_StartupPageLoadInfo.CountryPhoneCode,
      });
    }

    this.setState({ ContentLoading: false }, () => {
      setTimeout(() => {
        const phoneInput = document.getElementById("phoneno");
        if (phoneInput) {
          phoneInput.focus();
        }
      }, 0);
    });
  }

  async CheckPhone() {
    this.setState({ isLoading: true });
    var phoneno = document.getElementById("phoneno").value;
    if (phoneno.length > 5) {
      let CustomerMobileNumber =
        this.state.startingNo.replace("+", "") +
        document.getElementById("phoneno").value;
      let data = await api_CheckMobilePhoneNumber(CustomerMobileNumber);
      let objData = JSON.parse(data);
      let AppendData = JSON.parse(objData);
      if (AppendData[0][0].CSID > 0) {
        SET_STORE_STARTING_NO(this.state.startingNo);
        ENCRYPT_STORAGE.setItem(TEMP_STORE_CSID, AppendData[0][0].CSID);
        await api_SendOtp(CustomerMobileNumber);
        this.setState({ isLoading: false });
        this.props.navigate(PT_OTP);
      } else {
        this.props.navigate(PT_REGISTER);
      }
    } else {
      // Alert.MessageBox({
      //   Tittle: "Info",
      //   Icon: "error",
      //   ConfirmButtonText: "ok",
      //   Text: "Invlid Phone no",
      // });
      await ToastMessage(3, "Invlid Phone no");

      this.setState({ isLoading: false });
      return;
    }
  }

  removeZero(v) {
    if (v.charAt(0) === 0) {
      return v.slice(1);
    } else {
      return v;
    }
  }

  render() {
    return (
      <div
        className="profileLayout "
        style={{
          height: "100vh",
        }}
      >
        <div
          className="pgProfileLogo"
          style={{ backgroundColor: Colors.ThemeBGcolor }}
        >
          {this.state.ContentLoading ? (
            ""
          ) : (
            <img alt="logo" src={this.state.logosrc} />
          )}
        </div>
        <div
          style={{
            alignItems: "center",
            position: "fixed",
            top: 20,
            cursor: "pointer",
            fontSize: "18px",
          }}
          onClick={() => {
            let isFromPOS = ENCRYPT_STORAGE.getItem(ENTRY_MODE);
            if (isFromPOS === "QR") {
              this.props.navigate(PT_CART);
              return;
            } else {
              this.props.navigate(PT_PROFILE);
            }
          }}
        >
          {" "}
          <i className="fa fa-arrow-left" aria-hidden="true" />
        </div>
        <div>
          <p style={{ font: Font.MainHeading }}>Enter your mobile number</p>
        </div>
        <div className="profileSignNum">
          <button
            style={{
              width: "60px",
              height: "50px",
              fontSize: Font.Heading,
              border: "none",
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
            }}
          >
            <div style={{ display: "flex" }}>
              {this.state.ContentLoading ? (
                ""
              ) : (
                <img
                  src={this.state.logourl}
                  alt="logo"
                  width="80%"
                  style={{ marginTop: 3 }}
                />
              )}
            </div>
          </button>
          <div style={{ display: "flex" }}>
            <p
              style={{
                backgroundColor: "#f5f5f5",
                height: 50,
                margin: 0,
                marginLeft: 5,
                paddingTop: 18,
                paddingLeft: 15,
                fontSize: Font.Heading,
              }}
            >
              {this.state.startingNo}
            </p>
            <input
              className="profileSignInput"
              style={{
                fontSize: Font.Heading,
                border: "none",
                marginRight: 10,
              }}
              onChange={(e) => {
                e.currentTarget.value = this.removeZero(
                  e.currentTarget.value.replace(/[^0-9]/g, ""),
                );
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  document.getElementById("CheckPhoneBTN").click();
                }
              }}
              id="phoneno"
              name="phoneNumber"
              type="tel"
              pattern="[0-9]*"
              placeholder="Phone number"
              autoComplete="tel"
              maxLength={
                dto_common.CSP === "MK"
                  ? 9
                  : parseInt(dto_StartupPageLoadInfo.CountryPhoneLength)
              }
            />
          </div>
          {!this.state.isLoading ? (
            <button
              id="CheckPhoneBTN"
              style={{
                justifyContent: "center",
                justifyItems: "center",
                backgroundColor: Colors.DarkGreyScale,
                height: 48,
                width: 48,
                color: "white",
                fontSize: Font.MainHeading,
                border: "none",
                borderRadius: 3,
                cursor: "pointer",
              }}
              onClick={async () => {
                SET_STORE_TEMP_STORE_PHONE_NO(
                  this.state.startingNo.replace("+", "") +
                    document.getElementById("phoneno").value,
                );
                this.CheckPhone();
              }}
            >
              <i className="fa fa-arrow-right" aria-hidden="true" />
            </button>
          ) : (
            <button
              style={{
                justifyContent: "center",
                justifyItems: "center",
                backgroundColor: Colors.DarkGreyScale,
                height: 48,
                width: 48,
                color: "white",
                fontSize: Font.MainHeading,
                border: "none",
                borderRadius: 3,
                cursor: "pointer",
              }}
            >
              <i className="fa fa-circle-o-notch fa-spin" aria-hidden="true" />
            </button>
          )}
        </div>

        <DrawerSheetBottom
          open={this.state.CountryModleOpen}
          displayCloseIcon="block"
          element={
            <RENDER_DRAWER_COUNTRY
              SelectCountry={async (rs) => {
                this.setState({
                  CountryModleOpen: false,
                  logourl: rs.logourl,
                  CountryCode: rs.countrycode,
                  startingNo: rs.startingNo,
                });
              }}
            />
          }
        />
      </div>
    );
  }
}
